import { useEffect, useRef, useCallback } from 'react';

const InfiniteScroll = ({ onScrollEnd, isLoading, delay = 300, containerRef = null, direction = 'vertical' }) => {
  const timeoutRef = useRef(null);
  const onScrollEndRef = useRef(onScrollEnd);

  useEffect(() => {
    onScrollEndRef.current = onScrollEnd;
  }, [onScrollEnd]);

  const handleScroll = useCallback(() => {
    if (isLoading) return;

    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      let scrollPosition, threshold;

      if (containerRef?.current) {
        const container = containerRef.current;
        if (direction === 'horizontal') {
          scrollPosition = container.scrollLeft + container.clientWidth;
          threshold = container.scrollWidth - 50;
        } else {
          scrollPosition = container.scrollTop + container.clientHeight;
          threshold = container.scrollHeight - 200;
        }
      } else {
        scrollPosition = window.innerHeight + window.scrollY;
        threshold = document.documentElement.scrollHeight - 200;
      }

      if (scrollPosition >= threshold) {
        onScrollEndRef.current();
      }
    }, delay);
  }, [isLoading, delay, containerRef, direction]);

  useEffect(() => {
    const scrollTarget = containerRef?.current || window;

    scrollTarget.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timeoutRef.current);
      scrollTarget.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll, containerRef]);

  return null;
};

export default InfiniteScroll;
